import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { formatCurrency } from '@outlaw-oasis/utils';

export default function Orders() {
  const { data, isLoading } = useQuery({
    queryKey: ['orders'],
    queryFn: () => api.get('/orders'),
  });

  const orders = (data as any)?.data?.orders || [];

  if (isLoading) {
    return (
      <div>
        <h1 className="font-western text-3xl text-cream mb-8">My Orders</h1>
        <div className="space-y-4">
          {[1, 2, 3].map(i => (
            <div key={i} className="card p-6 animate-pulse">
              <div className="h-6 bg-leather rounded w-1/4 mb-4" />
              <div className="h-4 bg-leather rounded w-1/2" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div>
        <h1 className="font-western text-3xl text-cream mb-8">My Orders</h1>
        <div className="card p-8 text-center">
          <p className="text-text-secondary mb-4">You haven't made any orders yet.</p>
          <Link to="/products" className="btn-primary">
            Browse Products
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="font-western text-3xl text-cream mb-8">My Orders</h1>

      <div className="space-y-4">
        {orders.map((order: any) => (
          <Link
            key={order.id}
            to={`/dashboard/orders/${order.id}`}
            className="card p-6 block hover:border-gold/30 transition-colors"
          >
            <div className="flex items-center justify-between mb-4">
              <div>
                <span className="text-gold font-mono">#{order.orderNumber}</span>
                <span className="text-text-muted mx-3">|</span>
                <span className="text-text-secondary">
                  {new Date(order.createdAt).toLocaleDateString()}
                </span>
              </div>
              <div className="flex items-center gap-4">
                <span className={`px-2 py-1 rounded text-sm ${
                  order.status === 'completed' ? 'bg-success/20 text-success' :
                  order.status === 'pending_payment' ? 'bg-gold/20 text-gold' :
                  order.status === 'failed' ? 'bg-error/20 text-error' :
                  'bg-text-muted/20 text-text-muted'
                }`}>
                  {order.status === 'pending_payment' ? 'Pending Payment' :
                   order.status === 'completed' ? 'Completed' :
                   order.status === 'failed' ? 'Failed' :
                   order.status}
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <span className="text-text-secondary">
                {order.itemCount} item{order.itemCount !== 1 ? 's' : ''}
              </span>
              <span className="text-xl font-bold text-cream">
                {formatCurrency(order.total)}
              </span>
            </div>

            {order.paymentStatus === 'paid' && (
              <div className="mt-3 pt-3 border-t border-gold/10">
                <span className="text-success text-sm">
                  Click to view your purchased items and keys
                </span>
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
